import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getEducationsByApplicationId(applicationId: string) {
  return await prisma.applicantEducation.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
